import { ClustersSelect } from 'frontend/clusters'
import { ClustersService } from 'frontend/clusters/clusters-service'
import TaggableSelect from 'frontend/common/selects/taggable-select.vue'
import { VehicleCategoriesSelect } from 'frontend/vehicle-categories'
import { VehicleCategoriesService } from 'frontend/vehicle-categories/vehicle-categories-service'
import { VehicleModelsSelect } from 'frontend/vehicle-models'
import { VehicleModelsService } from 'frontend/vehicle-models/vehicle-models-service'
import { VehicleSourcesSelect } from 'frontend/vehicle-sources'
import { VehicleSourcesService } from 'frontend/vehicle-sources/vehicle-sources-service'
import { VehicleTypesSelect } from 'frontend/vehicle-types'
import { VehicleTypesService } from 'frontend/vehicle-types/vehicle-types-service'
import { VehiclesSelect } from 'frontend/vehicles'
import { VehiclesService } from 'frontend/vehicles/vehicles-service'
import { markRaw } from 'vue'

export const FILTERS_CONFIG = [
  {
    label: 'Tracker ID',
    kinds: ['cont', 'start', 'end'],
    attribute: 'remoteId',
  },
  {
    label: 'Name',
    kinds: ['cont', 'start', 'end'],
    attribute: 'name',
  },
  {
    label: 'Assigned Vehicle',
    attribute: 'vehicleId',
    kinds: ['in', 'notNull'],
    fetchSelectedItems: async ids => {
      if (ids?.length) {
        const response = await new VehiclesService().index({
          data: {
            normalized: false,
            idIn: ids.constructor == Array ? ids : [ids],
            fields: [
              'fleet_number',
              'registration_plate',
              { vehicle_model: ['name'] },
              { vehicle_brand: ['name'] },
            ],
          },
        })
        return Object.values(response?.contents || {})
          .map(
            c =>
              `${c.fleetNumber} ${c.vehicleBrand?.name} ${c.vehicleModel?.name}${
                c.registrationPlate?.length ? ' (' + c.registrationPlate + ')' : ''
              }`,
          )
          .join(', ')
      } else {
        return 'empty'
      }
    },
    slots: {
      in: {
        component: markRaw(VehiclesSelect),
        componentName: 'filters.vehicleIdIn',
      },
    },
    children: [
      {
        label: 'EID',
        attribute: 'vehicleEid',
        kinds: ['in', 'numberEq', 'gteq', 'lteq'],
        slots: {
          in: {
            component: markRaw(TaggableSelect),
            componentName: 'filters.vehicleEidIn',
            componentProps: {
              mainText: 'Type EID',
            },
          },
        },
      },
      {
        label: 'Fleet number',
        kinds: ['cont', 'start', 'end', 'notNull'],
        attribute: 'vehicleFleetNumber',
      },
      {
        label: 'Registration plate',
        kinds: ['cont', 'start', 'end', 'notNull'],
        attribute: 'vehicleRegistrationPlate',
      },
      {
        label: 'Cluster',
        kinds: ['in', 'notNull'],
        attribute: 'vehicleClusterId',
        fetchSelectedItems: async ids => {
          if (ids?.length) {
            const response = await new ClustersService().index({
              data: {
                idIn: ids.constructor == Array ? ids : [ids],
                fields: ['name'],
              },
            })
            return Object.values(response?.entities?.items || {})
              .map(c => c.name)
              .join(', ')
          } else {
            return 'empty'
          }
        },
        slots: {
          in: {
            component: markRaw(ClustersSelect),
            componentName: 'filters.vehicleClusterIdIn',
          },
        },
        children: [
          {
            label: 'EID',
            attribute: 'vehicleClusterEid',
            kinds: ['in', 'numberEq', 'gteq', 'lteq'],
            slots: {
              in: {
                component: markRaw(TaggableSelect),
                componentName: 'filters.vehicleClusterEidIn',
                componentProps: {
                  mainText: 'Type EID',
                },
              },
            },
          },
        ],
      },
      {
        label: 'Type',
        kinds: ['in', 'notNull'],
        attribute: 'vehicleVehicleTypeId',
        fetchSelectedItems: async ids => {
          if (ids?.length) {
            const response = await new VehicleTypesService().index({
              data: {
                idIn: ids.constructor == Array ? ids : [ids],
                fields: ['name'],
              },
            })
            return Object.values(response?.entities?.items || {})
              .map(c => c.name)
              .join(', ')
          } else {
            return 'empty'
          }
        },
        slots: {
          in: {
            component: markRaw(VehicleTypesSelect),
            componentName: 'filters.vehicleVehicleTypeIdIn',
          },
        },
      },
      {
        label: 'Model',
        kinds: ['in', 'notNull'],
        attribute: 'vehicleVehicleModelId',
        fetchSelectedItems: async ids => {
          if (ids?.length) {
            const response = await new VehicleModelsService().index({
              data: {
                normalized: false,
                idIn: ids.constructor == Array ? ids : [ids],
                fields: ['name', { vehicle_brand: ['name'] }],
              },
            })
            return Object.values(response?.contents || {})
              .map(c => `${c.vehicleBrand?.name} ${c.name}`)
              .join(', ')
          } else {
            return 'empty'
          }
        },
        slots: {
          in: {
            component: markRaw(VehicleModelsSelect),
            componentName: 'filters.vehicleVehicleModelIdIn',
          },
        },
      },
      {
        label: 'Category',
        kinds: ['in', 'notIn', 'notNull'],
        attribute: 'vehicleVehicleCategoryId',
        fetchSelectedItems: async ids => {
          if (ids?.length) {
            const response = await new VehicleCategoriesService().index({
              data: {
                idIn: ids.constructor == Array ? ids : [ids],
                fields: ['name'],
              },
            })
            return Object.values(response?.entities?.items || {})
              .map(c => c.name)
              .join(', ')
          } else {
            return 'empty'
          }
        },
        slots: {
          in: {
            component: markRaw(VehicleCategoriesSelect),
            componentName: 'vehicleVehicleCategoryIdIn',
          },
          notIn: {
            component: markRaw(VehicleCategoriesSelect),
            componentName: 'vehicleVehicleCategoryIdNotIn',
          },
        },
      },
      {
        label: 'Source',
        kinds: ['in', 'notIn', 'notNull'],
        attribute: 'vehicleVehicleSourceId',
        fetchSelectedItems: async ids => {
          if (ids?.length) {
            const response = await new VehicleSourcesService().index({
              data: {
                idIn: ids.constructor == Array ? ids : [ids],
                fields: ['name'],
              },
            })
            return Object.values(response?.entities?.items || {})
              .map(c => c.name)
              .join(', ')
          } else {
            return 'empty'
          }
        },
        slots: {
          in: {
            component: markRaw(VehicleSourcesSelect),
            componentName: 'vehicleVehicleSourceIdIn',
            componentProps: {
              hideAddButton: true,
            },
          },
          notIn: {
            component: markRaw(VehicleSourcesSelect),
            componentName: 'vehicleVehicleSourceIdNotIn',
            componentProps: {
              hideAddButton: true,
            },
          },
        },
        children: [
          {
            label: 'EID',
            attribute: 'vehicleVehicleSourceEid',
            kinds: ['in', 'numberEq', 'gteq', 'lteq'],
            slots: {
              in: {
                component: markRaw(TaggableSelect),
                componentName: 'filters.vehicleVehicleSourceEidIn',
                componentProps: {
                  mainText: 'Type EID',
                },
              },
            },
          },
        ],
      },
    ],
  },
  {
    label: 'Provider',
    kinds: ['cont', 'start', 'end'],
    attribute: 'provider',
  },
  {
    label: 'Updated at',
    kinds: ['datetimeWithVariablesGteq', 'datetimeWithVariablesLteq'],
    attribute: 'updatedAt',
  },
]
